import { ReactElement } from 'react';
export const StreamlinesAdvanced = ({ fill = 'none', stroke = 'currentColor' }: any): ReactElement => {
  return (
    <svg x="0px" y="0px" width={'24px'} height={'24px'} viewBox="0 0 36 36">
      <rect {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" x="2.5" y="2.5" width="31" height="31" />
      <line {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" x1="10" y1="10" x2="18" y2="18" />
      <line {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" x1="18" y1="10" x2="26" y2="18" />
      <line {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" x1="10" y1="18" x2="18" y2="26" />
      <line {...{ stroke, fill }} strokeWidth="1.5" strokeMiterlimit="10" x1="18" y1="18" x2="26" y2="26" />
    </svg>
  );
};
